import { render, staticRenderFns } from "./BtnGrid.vue?vue&type=template&id=5b94f6dc&scoped=true"
import script from "./BtnGrid.vue?vue&type=script&lang=js"
export * from "./BtnGrid.vue?vue&type=script&lang=js"
import style0 from "./BtnGrid.vue?vue&type=style&index=0&id=5b94f6dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b94f6dc",
  null
  
)

export default component.exports